import React from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";

export function CopyButton({ value, label = "Copy", className, testId }) {
  const [copied, setCopied] = React.useState(false);
  const onCopy = async (e) => {
    e?.stopPropagation?.();
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 1200);
    } catch {
      toast.error("Copy failed");
    }
  };
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={onCopy}
      aria-label={label}
      data-testid={testId}
      className={cn("text-[hsl(var(--muted))] hover:text-[hsl(var(--fg))]", className)}
    >
      {copied ? <Check size={14} /> : <Copy size={14} />}
    </Button>
  );
}
